import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-[#1c1a17] text-[var(--bg-paper)] mt-0">
      <div className="max-w-5xl mx-auto px-6 py-20 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img
              src="/press-kit/logo-192.png"
              alt="MiProse wax seal"
              width="48"
              height="48"
              className="object-contain"
              style={{
                width: 48,
                height: 48,
                imageRendering: "-webkit-optimize-contrast",
              }}
            />
            <span className="font-display text-xl">{t("nav.brand")}</span>
          </div>
          <p className="text-[#b8b1a4] leading-[1.8] max-w-xs whitespace-pre-line">{t("footer.tagline")}</p>
        </div>

        <nav className="text-[#b8b1a4] flex flex-col gap-3 text-[14px] md:items-center" aria-label="legal">
          <Link
            to="/rescue"
            data-testid="footer-rescue-link"
            className="hover:text-[var(--bg-paper)] transition-colors tracking-wide"
          >
            {t("footer.rescue")}
          </Link>
          <Link
            to="/press"
            data-testid="footer-press-link"
            className="hover:text-[var(--bg-paper)] transition-colors tracking-wide"
          >
            Press Kit
          </Link>
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="hover:text-[var(--bg-paper)] transition-colors tracking-wide"
          >
            {t("footer.privacy")}
          </Link>
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="hover:text-[var(--bg-paper)] transition-colors tracking-wide"
          >
            {t("footer.terms")}
          </Link>
        </nav>

        <div className="md:text-right text-[#b8b1a4] text-sm flex md:items-end md:justify-end">
          <p data-testid="footer-credit" className="md:whitespace-nowrap">
            {t("footer.credit_prefix", { year: new Date().getFullYear() })}
            <a
              href="https://dzentlimited.com/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-operator-link"
              className="text-[#6b665d] hover:text-[var(--bg-paper)] border-b border-transparent hover:border-[#8b8275] transition-colors duration-300"
            >
              {t("footer.credit_company")}
            </a>
            {t("footer.credit_suffix")}
          </p>
        </div>
      </div>
    </footer>
  );
};
